<a
    *appHasPermissionId="permissionList.planRead; else justNameTemplateRef"
    [routerLink]="['', 'plan', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
